<template>
    <div class="vue-block">
        <div class="container individual-list__container">
            <div v-if="!preloader">
                <a class="lists__nav" :href="kadraGlobal.Url">
                    Home /
                </a>
                <a class="lists__nav" :href="kadraGlobal.Url + '/my-account/'">
                    My Account /
                </a>
                <a class="lists__nav" :href="kadraGlobal.Url + '/mylist/'">
                    My Lists /
                </a>
                <a class="lists__nav" href="javascript:;">
                    {{ checkTitle() }}
                </a>
            </div>

            <span class="individual-list__back" @click="backUrl()"
                >Back to lists</span
            >
            <h2
                v-if="!condition"
                class="section-title individual-list__title"
                v-html="heading"
            ></h2>
            <div v-else-if="!preloader">
                <h2
                    class="section-title individual-list__title"
                    v-if="!hiddenEditInput"
                    v-html="displayTitle()"
                ></h2>
                <div
                    v-if="hiddenEditInput"
                    class="product-info-box__add-list-input"
                >
                    <input
                        type="text"
                        :value="wishlist.title"
                        ref="inputTitle"
                    />
                    <a
                        class="product-info-box__add-list-btn js-product-info-box__add-list-btn"
                        href="javascript:;"
                        @click="editWishlist(wishlist.ID)"
                        >Save</a
                    >
                </div>
            </div>

            <div class="individual-list__info" v-if="!preloader">
                <div class="individual-list__info-left" v-if="wishlist.created_at">
                    <span
                        class="individual-list__info-left-edited"
                        v-html="'Last Edited: ' + checkDate(wishlist.created_at)"
                    ></span>
                </div>
                <div class="individual-list__info-right" v-if="condition">
                    <a
                        class="individual-list__info-right-edit"
                        href="javascript:;"
                        @click="hiddenEditInput = !hiddenEditInput"
                    >
                        <SvgIcon
                            class="individual-list__info-right-icon"
                            iconName="ico-edit"
                        />
                    </a>
                    <a
                        class="individual-list__info-right-delete"
                        href="javascript:;"
                        @click="togglePopup"
                    >
                        <SvgIcon
                            class="individual-list__info-right-icon"
                            iconName="ico-trash"
                        />
                    </a>
                </div>
            </div>
            <div class="preloader-container" v-if="preloader">
                <span class="loader"></span>
            </div>
            <Controller
                v-if="status !== 'recommendations' && !preloader"
                :all="all"
                :products="products"
                :checkedProduct="checkedProduct"
                :wishlist="wishlist"
                v-on:isCheckAllFun="isCheckAllFun"
                v-on:deleteItems="deleteItems"
                v-on:addToCartItems="addToCartManyItems"
                v-on:unselectProduct="unselectProduct"
            />
            <div class="individual-list__items" v-if="!preloader">
                <div class="container">
                    <Product
                        :products="products"
                        :isCheckAll="isCheckAll"
                        :wishlist="wishlist"
                        :cart="cart"
                        :status="status"
                        :addToCartLoading="addToCartLoading"
                        :kadraGlobal="kadraGlobal"
                        :removeCheckedProduct="removeCheckedProduct"
                        v-on:checkedProducts="checkedProducts"
                    />
                </div>
            </div>
        </div>
        <div
            v-if="
                (status !== 'favorites' ||
                    status !== 'recommendations' ||
                    status !== 'viewed')
            "
            v-show="popupShow"
            class="popup-list-pop js-popup"
        >
            <div class="popup__content popup__content--list">
                <p class="popup__content-text">
                    Are you sure you want to delete the list?
                </p>
                <div class="popup__content-btn-wrapper">
                    <a
                        class="btn popup__content-btn popup__content-btn--list-cancel"
                        data-fancybox-close
                        href="javascript:;"
                        @click="popupShow = !popupShow"
                        >Cancel</a
                    >
                    <a
                        class="btn popup__content-btn popup__content-btn--list-delete"
                        href="javascript:;"
                        @click="removeWishlistAndList()"
                        >Delete</a
                    >
                </div>
            </div>
        </div>
        <!-- .popup -->
    </div>
    <!-- .individual-list -->
</template>

<script>
import { mapState } from 'vuex';
import Product from './parts/Product.vue';
import Controller from './parts/Controller.vue';
import SvgIcon from '../../base/SvgIcon/SvgIcon.vue';

export default {
    computed: mapState({
        singleWishlist: state => state.SingleList.singleWishlist,
        products: state => state.SingleList.products,
        addToCartLoading: state => state.Cart.addToCartLoading,
        cart: state => state.Cart.cart,
        wishlist: state => state.SingleList.wishlist,
        allFromlist: state => state.List.wishlist
    }),
    components: {
        Product,
        Controller,
        SvgIcon
    },
    data() {
        return {
            kadraGlobal: kadraGlobal,
            checkedProduct: [],
            isCheckAll: false,
            status: '',
            heading: '',
            all: [],
            hiddenEditInput: false,
            popupShow: false,
            condition: false,
            removeCheckedProduct: false,
            id: null,
            preloader: true,
        };
    },
    beforeMount() {
        const id = this.getUrl();
        switch (id) {
            case 'recommendations':
                this.status = 'recommendations';
                this.heading = 'My Recommendations';
                break;
            case 'favorites':
                this.status = 'favorites';
                this.heading = 'Favorites';
                break;
            case 'viewed':
                this.status = 'viewed';
                this.heading = 'Recently Viewed';
                break;
            default:
                this.status = 'id';
                break;
        }
        this.$store.dispatch('getWishlist');
        this.$store.dispatch('getAllCart');
        this.$store.dispatch('getSingleWishlist', id);
        this.conditions();
    },
    watch: {
        singleWishlist() {
            this.setData();
            this.preloader = false;
        },
        wishlist() {
            // document.title = this.wishlist.title;
            this.preloader = false;
        },
        products() {
            this.preloader = false;
        }
    },
    methods: {
        checkTitle() {
            if (this.wishlist.title === undefined) {
                const str = this.status;
                return str === 'id' ? '' : str.charAt(0).toUpperCase() + str.slice(1);
            }
            return this.wishlist.title;
        },
        backUrl() {
            window.location.href = this.kadraGlobal.Url + '/mylist';
        },
        unselectProduct() {
            this.preloader = true;
            this.removeCheckedProduct = !this.removeCheckedProduct;
        },
        getUrl() {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const id = urlParams.get('id');
            this.id = id;
            if (id) {
                return id;
            } else {
                window.location.href = this.kadraGlobal.Url + '/mylist';
            }
        },
        setData() {
            const BuiltInLists = [
                { ID: 'favorites', title: 'Favorites' }
            ].filter(item => item.ID !== this.status);
            if (
                this.singleWishlist.wishlist &&
                this.singleWishlist.wishlist.length !== 0
            ) {
                // this is custom list
                const arr = this.singleWishlist.allWishlist.filter(
                    item => item.ID !== this.singleWishlist.wishlist[0].ID
                );
                this.all = BuiltInLists.concat(arr);
            } else {
                // this is built-in list
                this.all = BuiltInLists.concat(this.singleWishlist.allWishlist);
                this.$store.dispatch('changeWishList', this.status);
            }
        },
        checkDate(date) {
            if (date !== undefined) {
                const spl = date.split(' ');
                const dateSpl = spl[0].split('-');
                return dateSpl[1] + '/' + dateSpl[2] + '/' + dateSpl[0];
            }
            return '?';
        },
        checkedProducts(arr) {
            this.checkedProduct = arr;
        },
        isCheckAllFun() {
            this.isCheckAll = !this.isCheckAll;
        },
        deleteItems() {
            if (this.checkedProduct.length !== 0) {
                this.preloader = true;
                this.$store.dispatch('removeManyFromWishlist', {
                    arr: this.checkedProduct,
                    wish_id: this.wishlist.ID
                });
                this.unselectProduct();
            }
        },
        addToCartManyItems() {
            if (this.checkedProduct.length !== 0) {
                this.preloader = true;
                const items = [];
                this.checkedProduct.forEach(v => {
                    items.push(v.ID + '-' + /*v.case_pack*/ '1');
                });
                this.$store.dispatch('addManyItemsToCart', {
                    items: items.join(';')
                });
            }
        },
        editWishlist(wishId) {
            const val = this.$refs.inputTitle.value;
            const obj = this.allFromlist.find(
                x => x.title.toLowerCase() === val.toLowerCase()
            );
            if (obj) {
                this.$refs.inputTitle.classList.add('list-name-input-invalid');
                return;
            }

            if (val !== '' && val.replace(/\s/g, '').length) {
                const obj = {
                    wishId: wishId,
                    title: val
                };
                this.$store.dispatch('editTitle', obj);
                this.hiddenEditInput = false;
            }
        },
        removeWishlistAndList() {
            console.log('item removing');
            document.querySelector('.popup__content-btn--list-delete').classList.add('show-loader');
            const ids = [];
            this.products.forEach(element => ids.push(element.ID.toString()));
            const obj = {
                wishId: this.wishlist.ID,
                ids: ids
            };
            this.$store.dispatch('removeWishlistAndList', obj);
        },
        conditions() {
            let flag = true;
            if (
                this.status === 'favorites' ||
                this.status === 'recommendations' ||
                this.status === 'viewed'
            ) {
                flag = false;
            }
            this.condition = flag;
        },
        displayTitle() {
            const itemLabel = this.products.length === 1 ? 'Item' : 'Items';
            return `${this.wishlist.title} (${this.products.length} ${itemLabel})`;
        },
        togglePopup() {
            this.popupShow = !this.popupShow;
        }
    }
};
</script>

<style lang="scss" scoped>
.preloader-container {
    position: relative;
    width: 100%;
    height: 200px;
    display: block;

    .loader {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 50px;

        @include mq($lg) {
            left: 48%;
            font-size: 35px;
        }

        @include mq(640px) {
            left: 45%;
        }
    }
}

.popup {
    display: none;
}

.product-info-box__add-list-input {
    display: flex;

    input {
        min-width: 283px;
        height: 49px;
        box-shadow: inset 0 3px 7px rgba(0, 0, 0, 0.11);
        border-radius: 5px;
        border: 1px solid #969696;
        background-color: #fff;
        padding: 0 24px;

        @include mq($sm) {
            min-width: 150px;
            max-width: 180px;
            padding: 10px;
        }
    }
}

.product-info-box__add-list-btn {
    width: 80px;
    margin-left: 10px;
    height: 49px;
    border-radius: 5px;
    border: 1px solid $theme-green;
    background-color: rgba(0, 190, 157, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    color: $theme-green;
    font-family: $font-second;
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    text-transform: uppercase;
    transition: 350ms ease-in-out;

    @include hover {
        background-color: rgba(240, 194, 1, 0.1);
        border: 1px solid $yellow;
        color: $yellow;
    }
}

.vue-block {
    position: relative;
}

.popup__content-text {
    text-align: center;

    @include mq($sm) {
        margin-bottom: 20px;
    }
}

.popup__content-btn-wrapper {
    @include mq($sm) {
        flex-direction: column;
    }
}

.popup__content--list {
    background: #fff;
    border-radius: 4px;

    @include mq($lg) {
        padding: 30px;
    }

    @include mq($sm) {
        max-width: 90%;
        width: 100%;
        padding: 20px;
    }
}

@keyframes rotation {
    0% {
        transform: translateY(-50%) rotate(0deg);
    }
    100% {
        transform: translateY(-50%) rotate(360deg);
    }
}

.popup__content-btn {
    position: relative;

    @include mq($xl) {
        padding: 5px 38px;
    }

    @include mq($md) {
        padding: 5px 25px;
        max-width: 47%;
        width: 100%;
    }

    @include mq($sm) {
        margin-bottom: 5px;
        max-width: 200px;
    }
}

.popup__content-btn--list-delete {
    position: relative;

    &.show-loader {
        &::after {
            position: absolute;
            content: '';
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            width: 18px;
            height: 18px;
            border: 2px solid $theme-green;
            border-bottom-color: transparent;
            border-radius: 50%;
            display: inline-block;
            box-sizing: border-box;
            animation: rotation 1s linear infinite;
        }
    }
}

.popup__content-btn--list-cancel {
    background-color: #969696;

    &:hover {
        background-color: #000;
        border-color: #000;
    }
}

.product-info-box__add-list-input .list-name-input-invalid {
    border: 1px solid $red;
}

.popup-list-pop {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: $black, $alpha: 0.4);
    z-index: 99999;

    .popup__content {
        max-width: 400px;
        position: absolute;
        width: 100%;
        padding: 20px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>
